import React from 'react';
import { WppPillGroup, WppPill } from '@wppopen/components-library-react';
import { normalizeString } from 'utils';

type SingleItem = {
    label: string;
    id: string;
};

interface IPill {
    value: string;
    handleChange: any;
    cases: SingleItem[];
    pillName: string;
    isDisabled?: boolean;
    dataTestId: string;
}

export const Pill = ({ value, handleChange, cases, pillName, isDisabled, dataTestId }: IPill) => {
    return (
        <WppPillGroup
            value={value}
            onWppChange={(e) => handleChange('highlighted', e.detail.value)}
            name={pillName}
            data-testid={dataTestId}
        >
            {cases.map((element: any) => (
                <WppPill
                    disabled={isDisabled}
                    label={element.label}
                    value={element.id}
                    key={element.id}
                    data-testid={`${dataTestId}.${normalizeString(element.label)}`}
                />
            ))}
        </WppPillGroup>
    );
};
